import React from "react";
import { Box, Typography } from "@mui/material";
import { COULEUR_DOMAINE, Domaine } from "../../theme/tribeTheme";
import { CarreDomaine } from "./Bloc";
import BoutonAide from "./BoutonAide";

/* Titre de page des écrans existants : carré de domaine, Montserrat, bouton
   d'aide. Remplace leur ancien titre sans toucher au reste de l'en-tête.
   L'aide est obligatoire : son texte vient de src/aide/textesAide.ts. */
export default function TitrePage({ domaine, children, aide }: { domaine: Domaine; children: React.ReactNode; aide: string }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 0.5 }}>
      <CarreDomaine couleur={COULEUR_DOMAINE[domaine]} taille={12} />
      <Typography component="h1" sx={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: { xs: 22, md: 26 }, lineHeight: 1.2, color: "var(--c-text-primary)" }}>
        {children}
      </Typography>
      <BoutonAide texte={aide} />
    </Box>
  );
}
